import { render, staticRenderFns } from "./SingleTPA.vue?vue&type=template&id=7b6b3d88&"
import script from "./SingleTPA.vue?vue&type=script&lang=js&"
export * from "./SingleTPA.vue?vue&type=script&lang=js&"
import style0 from "./SingleTPA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports